import React, { Fragment, useState, useContext, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AddIcon from '@material-ui/icons/Add';
import { ActionIcon } from '@mummssoftware/common-ui';
import { CPPContext } from '../Context/CPPContext';
import { hasPlanTasks } from '../Context/utils';
import { Context } from '../../context';
import {
  SET_CPP,
  SET_CPP_TASKS,
  Rendering,
  Editing,
} from '../Context/constants';

const ITEM_HEIGHT = 38;

const useStyles = makeStyles(() => ({
  menuPaper: { maxHeight: ITEM_HEIGHT * 6, width: 300 },
  menuItem: {
    paddingTop: '3px',
    paddingBottom: '3px',
    fontSize: '1rem',
    whiteSpace: 'break-spaces',
  },
}));

type CarePlanMenuProps = {
  newCarePlans: mumms.carePlanProblem[];
};

export const CarePlanMenu = ({ newCarePlans }: CarePlanMenuProps) => {
  const classes = useStyles();
  const { dispatch, cppForm, canEditCPPRoleGroup, getOtherTask } = useContext(
    CPPContext,
  );
  const { observation, agency } = useContext(Context);

  const [anchorEl, setAnchorEl] = useState(null);
  const [disabled, setDisabled] = useState(false);

  // disable add a plan
  useEffect(() => {
    if (cppForm && (cppForm.type === Editing || cppForm.type === Rendering)) {
      setDisabled(true);
    }
    if (!cppForm) {
      setDisabled(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cppForm && cppForm.type]);

  const onOpen = (e: any) => {
    setAnchorEl(e.currentTarget);
  };

  const onClose = () => {
    setAnchorEl(null);
  };

  /**
   * Add a new care plan problem from AddIcon
   * - get CPP form definition
   * - get Tasks definition if needed
   * - type is RENDERING
   */
  const getCarePlan = async (
    cpp: mumms.carePlanProblem,
    userAgency: string,
  ) => {
    // get CPP Tasks
    if (hasPlanTasks(cpp)) {
      // call endpoint task by cpp
      const tasksResponse = await observation.getCppTasksById(
        cpp.id,
        userAgency,
      );
      // get Other task
      await getOtherTask(cpp.id, Rendering);

      if (!(tasksResponse instanceof Response)) {
        dispatch({
          type: SET_CPP_TASKS,
          payload: tasksResponse,
        });
      }
    }
    const cppResponse = await observation.getCarePlanProblemById(
      cpp.id,
      userAgency,
    );
    // new forms
    if (!(cppResponse instanceof Response)) {
      // open the form
      dispatch({
        type: SET_CPP,
        payload: {
          ...cpp,
          careplanproblemdescription: cpp.description,
          careplanproblemshortname: cpp.shortname,
          careplanproblemname: cpp.name,
          id: cpp.id,
          type: Rendering,
          formdefinition: cppResponse.formdefinition.replaceAll('\\', ''),
        },
      });
      setAnchorEl(null);
    }
  };

  const openCarePlan = (cpp: mumms.carePlanProblem) => () => {
    getCarePlan(cpp, agency);
  };

  return canEditCPPRoleGroup ? (
    <Fragment>
      <ActionIcon
        Icon={AddIcon}
        title="Care Plans"
        style={{
          margin: 0,
          marginRight: 10,
          width: 20,
          height: 20,
        }}
        disabled={disabled}
        onClick={onOpen}
      />
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={onClose}
        PaperProps={{
          classes: {
            elevation8: classes.menuPaper,
          },
        }}
      >
        {(newCarePlans as any).map((item: mumms.carePlanProblem) => (
          <MenuItem
            key={item.shortname}
            onClick={openCarePlan(item)}
            className={classes.menuItem}
          >
            {item.shortname}
          </MenuItem>
        ))}
      </Menu>
    </Fragment>
  ) : (
    <></>
  );
};
export default CarePlanMenu;
